const Project = {
  state: {
    loadingProject: false,
    reports: [
      {
        image: "bestEmployee.png",
        link: "https://drive.google.com/file/d/1UMIlmXo1g4SOlxDNa77H9QTkTbxo5ChS/view",
      },
      {
        image: "googleCloude.png",
        link: "https://www.credly.com/users/bintang-mochamad-yussuf/badges#credly",
      },
      {
        image: "hacktiv8.webp",
        link: "https://drive.google.com/file/d/1HRodP9mY81m1nEHUtyaxTm6CMkHFTGPQ/view",
      },
      {
        image: "feecodecamp.webp",
        link: "https://www.freecodecamp.org/certification/BintangMy/responsive-web-design",
      },
      {
        image: "progateJS.webp",
        link: "https://progate.com/course_certificate/46b45cc4r2abf6",
      },
      {
        image: "progateReactJS.webp",
        link: "https://progate.com/course_certificate/9612eef1r2p0it",
      },
      {
        image: "progateNodeJS.webp",
        link: "https://progate.com/path_certificate/f221fdc3r35pjm",
      },
      {
        image: "progateHTML.webp",
        link: "https://progate.com/course_certificate/0be4d0e6qmkfqr",
      },
      {
        image: "sololearnJS.webp",
        link: "https://www.sololearn.com/Certificate/CT-NRUUR96T/png",
      },
      {
        image: "sololearnHTML.webp",
        link: "https://www.sololearn.com/Certificate/CT-EU3T04JM/jpg",
      },
      {
        image: "sololearnCSS.webp",
        link: "https://www.sololearn.com/Certificate/CT-QPPNZUDV/jpg",
      },
      {
        image: "dicodingWEB.webp",
        link: "https://www.dicoding.com/certificates/0LZ01DGD0P65",
      },
      {
        image: "dicodingFE.webp",
        link: "https://www.dicoding.com/certificates/07Z6RW17YPQR",
      }
    ],
    report: [],
  },
  mutations: {
    SET_LOADING_PROJECT(state, payload) {
      state.loadingProject = payload;
    },
    SET_REPORT(state, payload) {
      state.report = payload;
    },
  },
  actions: {},
};

export default Project;
